module.exports = __webpack_public_path__ + "static/img/close.e51618b0.svg";